import styled from "@emotion/styled";
import DisplayType from "utils/displayType";
import { useLayoutEffect } from "react";
import { updateTitle } from "utils/commonUtil";
import { useLanguage } from "i18n/LanguageContext";
import { renderText } from "i18n/TranslatedText";
import Footer from "../../component/footer/Footer";
import { ReactComponent as Logo } from "../../assets/logo_start_point.svg";
import StartingPointLogo from "../../assets/logo_start_point.png";
import StartingPointWord from "../../assets/starting_point_word.png";
import { ReactComponent as Email } from "../../assets/email__icon.svg";

const StartPoint = () => {
  const mode = DisplayType();
  const { t } = useLanguage();

  useLayoutEffect(() => {
    updateTitle(t("program", "startingPoint.pageTitle"));
  }, [t]);

  return (
    <Container>
      <HeaderContainer>
        <img
          className="program__logo"
          src={StartingPointLogo}
          alt="startingPointLogo"
        />
        <span
          className={`program__title ${
            mode === "Mobile" ? "font-bold-24" : "font-title"
          }`}
        >
          {t("program", "startingPoint.name")}
        </span>
        <p
          className={`program__description ${
            mode === "Mobile" ? "font-body3" : "font-body2"
          }`}
        >
          {renderText(t("program", "startingPoint.desc"), mode)}
        </p>
      </HeaderContainer>
      <BodyContainer className="limit__body">
        <ProgramDescription>
          <div
            className={`program__description__title ${
              mode === "Mobile" ? "font-sub-title2" : "font-title"
            }`}
          >
            {t("program", "startingPoint.communityTitle")}
          </div>
          <p className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}>
            {t("program", "startingPoint.communityDesc1")}
            <br />
            <br /> {t("program", "startingPoint.communityDesc2")}
          </p>
        </ProgramDescription>
        <ProgramProcess>
          <div
            className={`program__process__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "startingPoint.membership")}
          </div>
          <div className={`program__process__row`}>
            <span
              className={`${
                mode === "Mobile" ? "font-bold-16" : "font-bold-18"
              }`}
            >
              {t("program", "startingPoint.descLabel")}
            </span>
            <span
              className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            >
              {t("program", "startingPoint.descValue")}
            </span>
          </div>
          <div className={`program__process__row`} style={{ marginTop: 8 }}>
            <span
              className={`${
                mode === "Mobile" ? "font-bold-16" : "font-bold-18"
              }`}
            >
              {t("program", "startingPoint.targetLabel")}
            </span>
            <span
              className={`${mode === "Mobile" ? "font-body3" : "font-body2"}`}
            >
              {t("program", "startingPoint.targetValue")}
            </span>
          </div>
          {mode === "Mobile" && (
            <img
              className="program__process__img"
              style={{ padding: 12 }}
              src={StartingPointWord}
              alt="startingpoint word img"
            />
          )}

          {mode !== "Mobile" && (
            <img
              className="program__process__img"
              style={{ width: 960, margin: "0 auto", marginTop: 72 }}
              src={StartingPointWord}
              alt="startingpoint word img"
            />
          )}
        </ProgramProcess>
        <ProgramProcess>
          <div
            className={`program__process__title ${
              mode === "Mobile" ? "font-bold-22" : "font-sub-title"
            }`}
          >
            {t("program", "startingPoint.contact")}
          </div>
          <FlexRow
            className={`${
              mode === "Mobile" ? "font-regular-16" : "font-regulra-22"
            }`}
            style={{
              marginTop: 16,
              flexDirection: mode === "Mobile" ? "column" : "row",
              alignItems: mode === "Mobile" ? undefined : "center",
            }}
          >
            <span style={{ width: 80, fontWeight: 700 }}>
              {t("program", "startingPoint.emailLabel")}
            </span>
            <a
              href="mailto:startingpoint@bluepoint.ac"
              style={{ textDecoration: "none" }}
              rel="noreferrer"
            >
              <EmailContainer>
                <span className={`email__text `}>
                  startingpoint@bluepoint.ac
                </span>
              </EmailContainer>
            </a>
          </FlexRow>

          <FlexRow
            className={`${
              mode === "Mobile" ? "font-regular-16" : "font-regulra-22"
            }`}
            style={{
              marginTop: 12,
              flexDirection: mode === "Mobile" ? "column" : "row",
              alignItems: mode === "Mobile" ? undefined : "center",
            }}
          >
            <span style={{ width: 80, fontWeight: 700 }}>
              {t("program", "startingPoint.websiteLabel")}
            </span>
            <a
              href="https://startingpoint.co.kr"
              style={{ textDecoration: "none" }}
              rel="noreferrer"
            >
              <EmailContainer>
                <span className={`email__text `}>
                  https://startingpoint.co.kr
                </span>
              </EmailContainer>
            </a>
          </FlexRow>

          <FlexRow
            className={`${
              mode === "Mobile" ? "font-regular-16" : "font-regulra-22"
            }`}
            style={{
              marginTop: 12,
              flexDirection: mode === "Mobile" ? "column" : "row",
              alignItems: mode === "Mobile" ? undefined : "center",
            }}
          >
            <span style={{ width: 80, fontWeight: 700 }}>
              {t("program", "startingPoint.instagramLabel")}
            </span>
            <a
              href="https://www.instagram.com/startingpoint_official/"
              style={{ textDecoration: "none" }}
              rel="noreferrer"
            >
              <EmailContainer>
                <span className={`email__text `}>
                  https://www.instagram.com/startingpoint_official/
                </span>
              </EmailContainer>
            </a>
          </FlexRow>

          <FlexRow
            className={`${
              mode === "Mobile" ? "font-regular-16" : "font-regulra-22"
            }`}
            style={{
              marginTop: 12,
              flexDirection: mode === "Mobile" ? "column" : "row",
              alignItems: mode === "Mobile" ? undefined : "center",
            }}
          >
            <span style={{ width: 80, fontWeight: 700 }}>
              {t("program", "startingPoint.linkedinLabel")}
            </span>
            <a
              href="https://www.linkedin.com/in/starting-point-a32b30318/"
              style={{ textDecoration: "none" }}
              rel="noreferrer"
            >
              <EmailContainer>
                <span className={`email__text `}>
                  https://www.linkedin.com/in/starting-point-a32b30318/
                </span>
              </EmailContainer>
            </a>
          </FlexRow>
        </ProgramProcess>
      </BodyContainer>
      <Footer />
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 80px;

  @media only screen and (max-width: 768px) {
    padding-top: 60px;
  }
`;

const HeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-02);
  padding-top: 80px;
  padding-bottom: 80px;

  .program__logo {
    width: 240px;
    min-width: 240px;
    max-width: 240px;
    height: 240px;
    min-width: 240px;
    max-width: 240px;
    border-radius: 50%;
    border: 1px solid #e5e5ea;
    overflow: hidden;
    object-fit: contain;
    background-color: white;
  }
  .program__title {
    color: var(--black);
    margin-top: 24px;
    margin-bottom: 16px;
  }
  .program__description {
    color: var(--grey-40);
    text-align: center;
  }

  @media only screen and (max-width: 768px) {
    padding-bottom: 60px;
    .program__logo {
      width: 117px;
      min-width: 117px;
      max-width: 117px;
      height: 117px;
      min-width: 117px;
      max-width: 117px;
    }
    .program__title {
      color: var(--black);
      margin-top: 24px;
      margin-bottom: 8px;
    }
  }
`;

const BodyContainer = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  margin-bottom: 160px;
`;

const ProgramDescription = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .program__description__title {
    color: var(--primary);
    margin-bottom: 24px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__description__title {
      margin-bottom: 16px;
    }
  }
`;

const ProgramProcess = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 100px;

  .program__process__title {
    color: var(--black);
    margin-bottom: 24px;
  }

  .program__process__row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  .program__process__img {
    width: 100%;
    margin-top: 36px;
    /* border: 1px solid #e5e5ea; */
  }

  .program__process__list {
    width: 100%;
    border-top: 1px solid var(--grey-00);
    display: flex;
    flex-direction: column;
    margin-top: 24px;
  }
  @media only screen and (max-width: 768px) {
    margin-top: 40px;
    .program__process__title {
      margin-bottom: 16px;
    }
    .program__process__row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
  }
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const ProgramProcessItem = styled.div`
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--grey-00);

  .item__title {
    color: var(--primary);
  }
  .item__descrition {
    color: var(--grey-60);
  }
  @media only screen and (max-width: 768px) {
    padding: 24px 16px;
  }
`;

const EmailContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--primary);
`;
export default StartPoint;
